import React from "react";
import { Button, Tooltip } from "antd";
import {
  FilePdfOutlined,
  EditOutlined,
  DeleteOutlined,
} from "@ant-design/icons";

/**
 * Generate table columns for invoice data with nested taxInvoiceDataInfo
 */
export const getColumns = ({ onEdit, onDownload, onCancel }) => [
  {
    title: "Invoice No",
    dataIndex: ["taxInvoiceDataInfo", "invoiceNo"],
    key: "invoiceNo",
    sorter: (a, b) =>
      (a?.taxInvoiceDataInfo?.invoiceNo || "").localeCompare(
        b?.taxInvoiceDataInfo?.invoiceNo || ""
      ),
  },
  {
    title: "Date",
    dataIndex: ["taxInvoiceDataInfo", "date"],
    key: "date",
    render: (text) => new Date(text).toLocaleDateString(),
  },
  {
    title: "ShopName",
    dataIndex: ["taxInvoiceDataInfo", "shopName"],
    key: "shopName",
  },
  {
    title: "Total (₹)",
    dataIndex: ["taxInvoiceDataInfo", "totalAmount"],
    key: "totalAmount",
    render: (value) => `₹${Number(value || 0).toFixed(2)}`,
  },
  {
    title: "Paid (₹)",
    dataIndex: ["taxInvoiceDataInfo", "received"],
    key: "received",
    render: (value) => `₹${Number(value || 0).toFixed(2)}`,
  },
  {
    title: "Balance (₹)",
    dataIndex: ["taxInvoiceDataInfo", "balance"],
    key: "balance",
    render: (value) => `₹${Math.abs(Number(value || 0)).toFixed(2)}`,
  },
  {
    title: "Status",
    dataIndex: ["taxInvoiceDataInfo", "status"],
    key: "status",
  },
  {
    title: "Actions",
    key: "actions",
    fixed: "right",
    render: (_, record) => {
      const data = record?.taxInvoiceDataInfo || {};
      return (
        <div className="flex gap-2">
          <Tooltip title="Download PDF">
            <Button
              icon={<FilePdfOutlined />}
              onClick={() => onDownload(record)}
              size="small"
            />
          </Tooltip>
          <Tooltip title="Update Payment">
            <Button
              icon={<EditOutlined />}
              onClick={() => onEdit(record)}
              size="small"
            />
          </Tooltip>

          <Tooltip title="Cancel Invoice">
            <Button
              icon={<DeleteOutlined />}
              onClick={() => onCancel(record)}
              size="small"
              danger
              disabled={data?.status === "Cancelled"}
            />
          </Tooltip>
        </div>
      );
    },
  },
];
